import { Component } from '@angular/core';

@Component({
  selector: 'apex-empty-component',
  template: '',
})
export class EmptyComponent {}
